import React, { useState, useEffect } from "react";
import { Button, Input, Badge, Collapse } from "reactstrap";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";

/**
 * QuickReplyPanel - Panel hiển thị các mẫu trả lời nhanh
 * Phase 2: Quick Replies & Templates
 */
const QuickReplyPanel = ({ onSelectTemplate, isOpen, onToggle }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const categories = [
    { value: "", label: "Tất cả" },
    { value: "greeting", label: "Chào hỏi" },
    { value: "thanks", label: "Cảm ơn" },
    { value: "faq", label: "FAQ" },
    { value: "promotion", label: "Khuyến mãi" },
    { value: "general", label: "Chung" },
  ];

  useEffect(() => {
    if (isOpen) {
      loadTemplates();
    }
  }, [isOpen, selectedCategory]);

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const tokenStr = localStorage.getItem("access_token");
      let url = `${END_POINT}/api/quick-replies`;
      if (selectedCategory) {
        url += `?category=${selectedCategory}`;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      setTemplates(response.data.data || []);
    } catch (err) {
      console.error("Error loading quick replies:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredTemplates = templates.filter((t) => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase();
    return (
      t.title.toLowerCase().includes(q) ||
      t.content.toLowerCase().includes(q) ||
      (t.shortcut && t.shortcut.toLowerCase().includes(q))
    );
  });

  const getCategoryColor = (cat) => {
    switch (cat) {
      case "greeting":
        return "primary";
      case "thanks":
        return "success";
      case "faq":
        return "info";
      case "promotion":
        return "warning";
      default:
        return "secondary";
    }
  };

  return (
    <div className="quick-reply-panel">
      <div
        className="d-flex align-items-center justify-content-between p-2 border-bottom"
        style={{ cursor: "pointer" }}
        onClick={onToggle}
      >
        <span className="font-weight-semibold">
          <i className="simple-icon-bubbles mr-2" />
          Trả lời nhanh
        </span>
        <i className={`simple-icon-arrow-${isOpen ? "up" : "down"}`} />
      </div>

      <Collapse isOpen={isOpen}>
        <div className="p-2">
          <Input
            type="text"
            placeholder="Tìm mẫu tin nhắn..."
            value={searchQuery}
            onChange={handleSearch}
            bsSize="sm"
            className="mb-2"
          />

          <div className="d-flex flex-wrap mb-2">
            {categories.map((cat) => (
              <Badge
                key={cat.value}
                color={selectedCategory === cat.value ? "primary" : "light"}
                className="mr-1 mb-1 cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedCategory(cat.value)}
              >
                {cat.label}
              </Badge>
            ))}
          </div>

          {loading ? (
            <div className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </div>
          ) : filteredTemplates.length === 0 ? (
            <div className="text-center text-muted py-2">
              <small>Chưa có mẫu tin nhắn</small>
            </div>
          ) : (
            <div
              style={{ maxHeight: 200, overflowY: "auto" }}
              className="quick-reply-list"
            >
              {filteredTemplates.map((template) => (
                <div
                  key={template.id}
                  className="quick-reply-item p-2 border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => onSelectTemplate(template.content)}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <strong className="text-small">{template.title}</strong>
                    {template.shortcut && (
                      <code className="text-muted" style={{ fontSize: 10 }}>
                        {template.shortcut}
                      </code>
                    )}
                  </div>
                  <p
                    className="mb-0 text-muted small text-truncate"
                    style={{ maxWidth: "100%" }}
                  >
                    {template.content}
                  </p>
                  <Badge
                    color={getCategoryColor(template.category)}
                    className="mt-1"
                    style={{ fontSize: 9 }}
                  >
                    {template.category}
                  </Badge>
                </div>
              ))}
            </div>
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default QuickReplyPanel;
